import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

const movieApiKey = {
  api_key: '6b7407e10084c52d322a212cc0fdd4ff',
};

const createRequest = (url) => ({
  url,
  params: movieApiKey,
});

export const movieApi = createApi({
  reducerPath: 'movieApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://api.themoviedb.org/3' }),
  endpoints: (builder) => ({
    getMoviePopular: builder.query({
      query: () => createRequest(`movie/popular`),
    }),
    getMovies: builder.query({
      query: ({ page }) => createRequest(`movie/popular?page=${page}`),
    }),
    getSearchMovies: builder.query({
      query: ({ query, page }) =>
        createRequest(`/search/movie?query=${query}&page=${page}`),
    }),
    getMovieDetails: builder.query({
      query: ({ movieId }) => createRequest(`/movie/${movieId}`),
    }),
    getMovieVideos: builder.query({
      query: ({ movieId }) => createRequest(`movie/${movieId}/videos`),
    }),
    getMovieCredits: builder.query({
      query: ({ movieId }) => createRequest(`/movie/${movieId}/credits`),
    }),
    getMovieSimiliar: builder.query({
      query: ({ movieId }) => createRequest(`/movie/${movieId}/similar`),
    }),
    getTrending: builder.query({
      query: ({ mediaType, timeType }) =>
        createRequest(`trending/${mediaType}/${timeType}`),
    }),
    getPlayingMovie: builder.query({
      query: () => createRequest(`movie/now_playing`),
    }),
    getTopRatedMovie: builder.query({
      query: () => createRequest(`movie/top_rated`),
    }),
    getUpComingMovie: builder.query({
      query: () => createRequest(`movie/upcoming`),
    }),
    getTvPopular: builder.query({
      query: () => createRequest(`tv/popular`),
    }),
    getTv: builder.query({
      query: ({ page }) => createRequest(`tv/popular?page=${page}`),
    }),
    getTvDetails: builder.query({
      query: ({ tvId }) => createRequest(`/tv/${tvId}`),
    }),
    getTvVideos: builder.query({
      query: ({ tvId }) => createRequest(`tv/${tvId}/videos`),
    }),
    getTvCredits: builder.query({
      query: ({ tvId }) => createRequest(`/tv/${tvId}/credits`),
    }),
    getTvSimiliar: builder.query({
      query: ({ tvId }) => createRequest(`/movie/${tvId}/similar`),
    }),
    getTopRatedTv: builder.query({
      query: () => createRequest(`tv/top_rated`),
    }),
    getAiringTodayTv: builder.query({
      query: () => createRequest(`tv/airing_today`),
    }),
    getOnAirTv: builder.query({
      query: () => createRequest(`tv/on_the_air`),
    }),
  }),
});

export const {
  useGetMoviePopularQuery,
  useGetMoviesQuery,
  useGetSearchMoviesQuery,
  useGetMovieDetailsQuery,
  useGetMovieVideosQuery,
  useGetMovieCreditsQuery,
  useGetMovieSimiliarQuery,
  useGetTrendingQuery,
  useGetPlayingMovieQuery,
  useGetTopRatedMovieQuery,
  useGetUpComingMovieQuery,
  useGetTvPopularQuery,
  useGetTvQuery,
  useGetTvDetailsQuery,
  useGetTvVideosQuery,
  useGetTvCreditsQuery,
  useGetTvSimiliarQuery,
  useGetTopRatedTvQuery,
  useGetAiringTodayTvQuery,
  useGetOnAirTvQuery,
} = movieApi;
